import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") {
      return "light";
    }

    const savedTheme = window.localStorage.getItem("theme");
    if (savedTheme) {
      return savedTheme;
    }

    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  });

  useEffect(() => {
    if (!theme) {
      return;
    }

    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    window.localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <div className="min-h-screen">
      <div className="fixed inset-0 flex justify-center px-4 sm:px-8">
        <div className="w-full max-w-6xl bg-white/80 ring-1 ring-stone-200/80 backdrop-blur-sm dark:bg-stone-950/85 dark:ring-stone-800/80" />
      </div>
      <div className="relative mx-auto flex min-h-screen w-full max-w-6xl flex-col px-4 pb-12 sm:px-8">
        <Navbar theme={theme} setTheme={setTheme} />
        <main className="flex-1 pt-10 sm:pt-16">{children}</main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
